/* eslint-disable react/require-default-props */

import React from "react";
import Model from "@tripian/model";
import { StepCard } from "@tripian/react";

interface IDefaultStepCard {
  step: Model.Step;
  clicked: (step: Model.Step) => void;
  alternativePois: Model.Poi[];
  alternativePoisDays: number[][];
  alternativePoiCardClicked: (alternativePoi: Model.Poi) => void;
  alternativeReplace: (alternativePoi: Model.Poi) => void;
  showAlternativesChange: (stepId: number, show: boolean) => void;
  showAlternatives?: boolean;
  // showRemoveReplaceButtons?: boolean;
  hideScore?: boolean;
  hideStepsTime?: boolean;
  hideFeatures?: boolean;
  hideCuisine?: boolean;
  isWidget?: boolean;
  thumbs?: number;
  thumbsLoading?: boolean;
  thumbsClicked?: (like: number) => void;
  timesClicked: (from: string, to: string) => void;
  userReactionUndo?: () => void;
  userReactionRemoveStep?: () => void;
  onBookClick?: (step: Model.Step) => void;
  gygTourIds: number[];
  bbTourIds: number[];
  viatorTourIds: string[];
  toristyTourIds: string[];
  toursLoading: boolean;
  t: (value: Model.TranslationKey) => string;
}

const DefaultStepCard: React.FC<IDefaultStepCard> = ({
  step,
  clicked,
  alternativePois,
  alternativeReplace,
  showAlternativesChange,
  showAlternatives,
  // showRemoveReplaceButtons,
  hideStepsTime,
  hideFeatures,
  hideCuisine,
  isWidget,
  timesClicked,
  userReactionRemoveStep = () => {
    // eslint-disable-next-line no-console
    console.warn("StepCardUserReaction with undefined userReactionRemoveStep");
  },
  onBookClick,
  gygTourIds,
  bbTourIds,
  viatorTourIds,
  toristyTourIds,
  toursLoading,
  t,
}) => {
  // if (window.tconfig.SHOW_STEP_CARD_THUMBS && !isNaN(parseFloat(step.poi.id)))
  //   return (
  //     <StepCardUserReaction
  //       key={step.id}
  //       step={step}
  //       clicked={clicked}
  //       alternativePois={alternativePois}
  //       alternativePoisDays={alternativePoisDays}
  //       showAlternatives={showAlternatives}
  //       showAlternativesChange={showAlternativesChange}
  //       alternativePoiCardClicked={alternativePoiCardClicked}
  //       alternativeReplace={alternativeReplace}
  //       thumbs={thumbs}
  //       thumbsLoading={thumbsLoading || false}
  //       thumbsClicked={thumbsClicked}
  //       timesClicked={timesClicked}
  //       userReactionUndo={userReactionUndo}
  //       userReactionRemoveStep={userReactionRemoveStep}
  //       showRemoveReplaceButtons={showRemoveReplaceButtons}
  //       hideScore={hideScore}
  //       hideStepsTime={hideStepsTime}
  //       hideFeatures={hideFeatures}
  //       hideCuisine={hideCuisine}
  //       isWidget={isWidget}
  //       hideReservationIcon={!window.tconfig.SHOW_RESTAURANT_RESERVATIONS}
  //       hideTourTicketIcons={!window.tconfig.SHOW_TOURS_AND_TICKETS}
  //       hideOfferIcon={!window.tconfig.SHOW_OFFERS}
  //       TOUR_PROVIDER_IDS={window.tconfig.TOUR_TICKET_PROVIDER_IDS}
  //       TICKET_PROVIDER_IDS={window.tconfig.TOUR_TICKET_PROVIDER_IDS}
  //       RESTAURANT_RESERVATION_PROVIDER_IDS={window.tconfig.RESTAURANT_RESERVATION_PROVIDER_IDS}
  //       gygTourIds={gygTourIds}
  //       bbTourIds={bbTourIds}
  //       viatorTourIds={viatorTourIds}
  //       toristyTourIds={toristyTourIds}
  //       tourTicketProductsLoading={toursLoading}
  //       t={t}
  //     />
  //   );

  return (
    <StepCard
      key={step.id}
      step={step}
      clicked={clicked}
      showAlternatives={showAlternatives}
      showAlternativesChange={showAlternativesChange}
      alternativeReplace={alternativeReplace}
      timesClicked={timesClicked}
      userReactionRemoveStep={userReactionRemoveStep}
      onBookClick={onBookClick}
      alternativePois={alternativePois}
      hideReservationIcon={!window.tconfig.SHOW_RESTAURANT_RESERVATIONS}
      hideTourTicketIcons={!window.tconfig.SHOW_TOURS_AND_TICKETS}
      // hideOfferIcon={!window.tconfig.SHOW_OFFERS}
      TOUR_PROVIDER_IDS={window.tconfig.TOUR_TICKET_PROVIDER_IDS}
      TICKET_PROVIDER_IDS={window.tconfig.TOUR_TICKET_PROVIDER_IDS}
      RESTAURANT_RESERVATION_PROVIDER_IDS={
        window.tconfig.RESTAURANT_RESERVATION_PROVIDER_IDS
      }
      hideStepsTime={hideStepsTime}
      hideFeatures={hideFeatures}
      hideCuisine={hideCuisine}
      isWidget={isWidget}
      gygTourIds={gygTourIds}
      bbTourIds={bbTourIds}
      viatorTourIds={viatorTourIds}
      toristyTourIds={toristyTourIds}
      tourTicketProductsLoading={toursLoading}
      t={t}
    />
  );
};

export default DefaultStepCard;
